import StyledButton from 'components/Elements/StyledButton'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useState } from 'react'
import { Carousel, Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ModalVideo from 'react-modal-video'
import { useHistory } from 'react-router-dom'
import { HOME_VIDEO } from 'services/constants'
import '../../../../../node_modules/react-modal-video/scss/modal-video.scss'
import { HeroImgContainer, HomeHeroContainer } from './style'

const bgImages = [
  { img: 'https://image.anecdobio.com/home_hero1.jpg' },
  { img: 'https://image.anecdobio.com/home_hero3.jpg' },
  { img: 'https://image.anecdobio.com/home_hero4.jpg' },
  { img: 'https://image.anecdobio.com/home_hero5.jpg' },
  { img: 'https://image.anecdobio.com/home_hero6.jpg' },
  { img: 'https://image.anecdobio.com/home_hero7.jpg' },
  { img: 'https://image.anecdobio.com/home_hero8.jpg' },
  { img: 'https://image.anecdobio.com/home_hero9.jpg' },
  { img: 'https://image.anecdobio.com/home_hero11.jpg' },
  { img: 'https://image.anecdobio.com/home_hero12.jpg' },
  { img: 'https://image.anecdobio.com/home_hero13.jpg' },
  { img: 'https://image.anecdobio.com/home_hero14.jpg' },
]

function HomeHero() {
  const { lang } = useContext(DataContext)
  const [videoOpen, setVideoOpen] = useState(false)
  const history = useHistory()
  const { t } = useTranslation()

  const changeLocation = (e, placeToGo) => {
    // e.stopPropagation();
    // e.nativeEvent.stopImmediatePropagation();
    history.push(placeToGo)
    window.location.reload()
  }

  return (
    <HomeHeroContainer>
      <Container className="h-100">
        <Row className="h-100">
          <Col lg={6} md={12} sm={12} xs={12}>
            <div className="home-header-content">
              <h1>{t('home_hero_title')}</h1>
              <h3>{t('home_hero_description')}</h3>
              <div className="btns-wrapper">
                <StyledButton
                  className="btn-blue btn-get-started"
                  title={t('getstarted')}
                  onClick={(e) => changeLocation(e, '/get-started')}
                />
                <StyledButton
                  className="btn-transparent btn-watch"
                  title={t('watch_video')}
                  onClick={() => setVideoOpen(true)}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Carousel fade controls={false} interval={8000}>
        {bgImages.map((_bg, _i) => (
          <Carousel.Item key={_i}>
            <HeroImgContainer
              className="item2 slider-img"
              bg={_bg.img}
            ></HeroImgContainer>
          </Carousel.Item>
        ))}
      </Carousel>
      <ModalVideo
        youtube={{
          autoplay: 1,
          mute: 0,
        }}
        channel="youtube"
        isOpen={videoOpen}
        videoId={HOME_VIDEO['id'][lang]}
        onClose={() => setVideoOpen(false)}
      />
    </HomeHeroContainer>
  )
}

export default HomeHero
